import React from 'react'
import { Layout } from 'antd'
import './index.less'

const { Footer } = Layout

class CustomisedFooter extends React.Component {
  render() {
    return (
      <Footer className='app-footer'>
        © 2026 Temple Service limited.
      </Footer>
    )
  }
}

export default CustomisedFooter
